import type { Theme } from "@/configuration/vuetify";

export function useApiBetaVersion() {
  return localStorage.getItem("use-api-beta") === "true";
}

export function getTheme(): Theme {
  const persistedTheme = localStorage.getItem("theme");
  if (persistedTheme === "dark" || persistedTheme === "light") {
    return persistedTheme;
  }

  if (window.matchMedia("(prefers-color-scheme:dark)").matches) {
    return "dark";
  }

  return "light";
}

export function setTheme(theme: Theme) {
  localStorage.setItem("theme", theme);
}

const SETTINGS_KEY = "user-settings";

function readStore(): Record<string, unknown> {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) {
      return {};
    }
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return parsed as Record<string, unknown>;
  } catch {
    return {};
  }
}

export function readLocalSetting<T>(key: string): T | null {
  const store = readStore();
  if (!(key in store)) {
    return null;
  }
  return store[key] as T;
}

export function writeLocalSetting(key: string, value: unknown) {
  const store = readStore();
  if (JSON.stringify(store[key]) === JSON.stringify(value)) {
    return;
  }
  store[key] = value;
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(store));
}
